import { DefaultButton, Dialog, DialogFooter, PrimaryButton } from "@fluentui/react";
import { FixedList, Text } from "cayo.ui";
import React, { FC, useState } from "react";
import { useIntl } from "react-intl";
import { ILookupResultItem } from "../../../../api/schema.api";
import { commonMessages } from "@cayo/shared/messages/common";
import { globalSearchDialogColumns } from "./global-search-dialog-columns";
import { globalObjectSearchMessages } from "./messages";

const OBJECTS_OVERLOAD_NUMBER = 10;

interface GlobalObjectSearchDialogProps {
  objects: ILookupResultItem[];
  isDialogVisible: boolean;
  searchString?: string;
  dismissDialog: () => void;
  dismissAllDialogs: () => void;
  addObjects: (objects: any[]) => void;
}

const GlobalObjectSearchDialog: FC<GlobalObjectSearchDialogProps> = ({
  objects,
  isDialogVisible,
  searchString,
  dismissDialog,
  dismissAllDialogs,
  addObjects,
}) => {
  const { formatMessage } = useIntl();
  const [selectedObjects, setSelectedObjects] = useState<any[] | undefined>([]);

  return (
    <Dialog
      hidden={!isDialogVisible}
      minWidth={1000}
      dialogContentProps={{
        title: formatMessage(globalObjectSearchMessages.multipleNamesFound),
        subText: formatMessage(globalObjectSearchMessages.moreThanOneObjectMatched, {
          searchString,
        }),
      }}
      modalProps={{
        isBlocking: true,
      }}
      onDismiss={dismissDialog}
    >
      <FixedList
        label={formatMessage(globalObjectSearchMessages.matchingNames)}
        name="global-object-search-list"
        layoutMode="fixedColumns"
        selectionMode="multiple"
        setValue={() => {}}
        value={objects}
        columns={globalSearchDialogColumns}
        onSelectedItemsChange={(items) => setSelectedObjects(items)}
      />
      {objects.length >= OBJECTS_OVERLOAD_NUMBER && (
        <Text value={formatMessage(globalObjectSearchMessages.top10MatchesShown)} block />
      )}
      <DialogFooter>
        <PrimaryButton
          onClick={() => {
            addObjects(selectedObjects || []);
            dismissDialog();
          }}
          text={formatMessage(commonMessages.select)}
          disabled={!selectedObjects?.length}
        />
        <DefaultButton
          onClick={dismissDialog}
          text={formatMessage(globalObjectSearchMessages.skipThisObject)}
        />
        <DefaultButton onClick={dismissAllDialogs} text={formatMessage(commonMessages.cancel)} />
      </DialogFooter>
    </Dialog>
  );
};

export default GlobalObjectSearchDialog;
